
    <!-- ======= Resume Section ======= -->
    <section id="resume" class="resume">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Resume</h2>
          <!-- <p>Desarrollador de Aplicaciones Web, de Escritorio y Móvil, aplicando tecnologías modernas en base a requerimientos del usuario.</p> -->
        </div>

        <div class="row">
          <div class="col-lg-6">
            <h3 class="resume-title">Sumary</h3>
            <div class="resume-item pb-0">
              <h4>{{titular.nombre}}</h4>
              <p><em>{{resume.resumen}}</em></p>
              <!-- <ul>
                <li>Portland par 127,Orlando, FL</li>
                <li>(123) 456-7891</li>
                <li>alice.barkley@example.com</li>
              </ul> -->
            </div>

            <h3 class="resume-title">Educación</h3>
            <div class="resume-item">
              <h4>{{resume.universidad}}</h4>
              <h5>{{resume.periodo}}</h5>
              <p><em>{{resume.escuela}}{{resume.ubicacionUni}}</em></p>
              <p>Egresado de la {{resume.escuela}}</p>
            </div>
            <div class="resume-item">
              <h4>{{resume.instituto}}</h4>
              <h5>{{resume.periodoIns}}</h5>
              <p><em>{{resume.instituto}}{{resume.ubicacionUni}}</em></p>
              <h5>{{resume.nivelIngles}}</h5>
              <!-- <p>Quia nobis sequi est occaecati aut. Repudiandae et iusto quae reiciendis et quis Eius vel ratione eius unde vitae rerum voluptates asperiores voluptatem Earum molestiae consequatur neque etlon sader mart dila</p> -->
            </div>
          </div>
          <div class="col-lg-6" >
            <h3 class="resume-title">Experiencia Profesional</h3>
            <div class="resume-item" *ngFor="let exp of experiencias">
              <h4>{{exp.empresa}}</h4>
              <strong>Fecha:</strong><h5>{{exp.fechaIngreso}} - {{exp.fechaSalida}}</h5>
              <br>
              <strong>Área:</strong><h5>{{exp.area}}</h5>
              <br>
              <strong>Cargo:</strong><h5>{{exp.cargo}}</h5>
              <br>
              <strong>Actividad:</strong><p><em>{{exp.actividad}} </em></p>
              <!-- <ul>
                <li>Lead in the design, development, and implementation of the graphic, layout, and production communication materials</li>
                <li>Delegate tasks to the 7 members of the design team and provide counsel on all aspects of the project. </li>
                <li>Supervise the assessment of all graphic materials in order to ensure quality and accuracy of the design</li>
                <li>Oversee the efficient use of production project budgets ranging from $2,000 - $25,000</li>
              </ul> -->
            </div>
            <!-- <div class="resume-item">
              <h4>Graphic design specialist</h4>
              <h5>2017 - 2018</h5>
              <p><em>Stepping Stone Advertising, New York, NY</em></p>
              <ul>
                <li>Developed numerous marketing programs (logos, brochures,infographics, presentations, and advertisements).</li>
                <li>Managed up to 5 projects or tasks at a given time while under pressure</li>
                <li>Recommended and consulted with clients on the most appropriate graphic design</li>
                <li>Created 4+ design presentations and proposals a month for clients and account managers</li>
              </ul>
            </div> -->
          </div>
        </div>

      </div>
    </section><!-- End Resume Section -->
